import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CheckPlatformService } from "@apply4u/services/check-platform.service";
import { ChangesSavedSuccessfully_Message,InvalidFileFormate_Message, NotLoggedIn_Message } from '@apply4u/shared/constant/messages/common-notifications';
import { DeletedSuccessfully_Message } from '@apply4u/shared/constant/messages/common-notifications';
import { SavedSuccessfully_Message } from '@apply4u/shared/constant/messages/common-notifications';
import { ServerError_Message } from '@apply4u/shared/constant/messages/common-notifications';
import { UpdatedSuccessfully_Message } from '@apply4u/shared/constant/messages/common-notifications';

@Injectable({
  providedIn: 'root'
})
export class ToasterMessageService {

  constructor(private toaster: ToastrService,
    private checkPlatformService: CheckPlatformService,) {

  }

  Success(message: string, title?: string) {
    if (this.checkPlatformService.isBrowser()) {
      this.toaster.success(message, title);
    }
  }

  Warning(message?: string, title?: string) {
    if (this.checkPlatformService.isBrowser()) {
      this.toaster.warning(message, title);
    }
  }

  Error(message?: string, title?: string) {
    if (this.checkPlatformService.isBrowser()) {
      this.toaster.error(message, title);
    }
}

  Info(message?: string, title?: string) {
    if (this.checkPlatformService.isBrowser()) {
      this.toaster.info(message, title);
    }
  }

  ServerError() {
    this.Error(ServerError_Message);
  }

  LoginMessageError() {
    this.Error(NotLoggedIn_Message);
  }

  SavedSuccessfully() {
    this.Success(SavedSuccessfully_Message);
  }

  ChangesSavedSuccessfully() {
    this.Success(ChangesSavedSuccessfully_Message);
  }
  
  UpdatedSuccessfully() {
    this.Success(UpdatedSuccessfully_Message);
  }

  DeletedSuccessfully() {
    this.Success(DeletedSuccessfully_Message );
  }

  RegistrationFileFormatNotSupported() {
    this.Error( InvalidFileFormate_Message);
  }
}
